import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import { useState } from 'react';
import { OperationOverviewSection } from './OperationOverviewSection';
import { OperationParametersSection } from './OperationParametersSection';
import { OperationRequestBodySection } from './OperationRequestBodySection';
import { OperationResponsesSection } from './OperationResponsesSection';
import { OperationSummary } from './OperationSummary';
const backgroundColors = {
    blue: 'bg-blue-500/5',
    orange: 'bg-orange-500/5',
    green: 'bg-green-500/5',
    red: 'bg-red-500/5',
    zinc: 'bg-zinc-600/5'
};
const borders = {
    blue: 'border-blue-500/20 dark:border-blue-500/30',
    orange: 'border-orange-500/20 dark:border-orange-500/30',
    green: 'border-green-500/20 dark:border-green-500/30',
    red: 'border-orredange-500/20 dark:border-red-500/30',
    zinc: 'border-zinc-500/20 dark:border-zinc-500/30'
};
const methods = {
    get: 'blue',
    put: 'orange',
    post: 'green',
    delete: 'red',
    options: 'zinc',
    head: 'zinc',
    patch: 'orange',
    trace: 'zinc'
};
export function OperationListItem({ path, pathItem, method, operation }) {
    const [open, setOpen] = useState(false);
    return (_jsx("div", { className: clsx('w-full rounded border', backgroundColors[methods[method]], borders[methods[method]]), children: _jsxs(Disclosure, { children: [_jsx("div", { className: "relative", children: _jsxs(Disclosure.Button, { className: "p flex w-full items-center justify-between", onClick: () => setOpen(!open), children: [_jsx(OperationSummary, { path: path, method: method, operation: operation }), _jsx(ChevronUpIcon, { className: `${open ? 'rotate-180 transform' : ''} mr-2 h-5 w-5` })] }) }), open && (_jsxs(Disclosure.Panel, { static: true, className: clsx('border-t', borders[methods[method]]), children: [_jsx(OperationOverviewSection, { operation: operation }), _jsx(OperationParametersSection, { pathItem: pathItem, operation: operation }), _jsx(OperationRequestBodySection, { operation: operation }), _jsx(OperationResponsesSection, { operation: operation })] }))] }) }));
}
